import React from "react";
import { ThemeProvider } from "react-jss";
import { theme } from "constants/Theme";
import { OrderContainer } from "../order-container";
import { BannerProvider } from "../banner-provider/banner-provider";

export const OrderView = () => {
  return (
    <ThemeProvider theme={theme}>
      <BannerProvider>
        {(setBannerState) => (
          <OrderContainer setBannerState={setBannerState} />
        )}
      </BannerProvider>
    </ThemeProvider>
  );
};

export default OrderView;
